exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__button___Dv_TK{display:inline-block;font-family:Poppins-Light;font-weight:400;font-size:13px;letter-spacing:.6px;color:#333;background-color:#f8d0ca;border:0;cursor:pointer;vertical-align:middle;margin:0 1em 0 0;padding:11px 20px 9px;outline:none;transition:all .1s ease-in-out}.style__button___Dv_TK.style__fixedWidth___YpL7t{width:165px;overflow:hidden;text-overflow:ellipsis}.style__button___Dv_TK.style__tall___2Zns_{height:60px}.style__button___Dv_TK span{display:block}.style__button___Dv_TK span svg{margin-top:-4px}.style__button___Dv_TK.style__alt___1pBrO{background:none;border:2px solid #f8d0ca}.style__button___Dv_TK.style__disabled___3kqrL{background:#e5e5e5;color:#999;cursor:auto}.style__button___Dv_TK.style__center___1MZ6C{display:block;margin-left:auto;margin-right:auto}.style__button___Dv_TK.style__compare___2sYLi{display:block;margin:0 auto;width:180px}.style__button___Dv_TK.style__bottom___3HKIF{position:absolute;bottom:0}.style__button___Dv_TK.style__transparentBg___3_IEC{background-color:unset}", ""]);

// exports
exports.locals = {
	"button": "style__button___Dv_TK",
	"fixedWidth": "style__fixedWidth___YpL7t",
	"tall": "style__tall___2Zns_",
	"alt": "style__alt___1pBrO",
	"disabled": "style__disabled___3kqrL",
	"center": "style__center___1MZ6C",
	"compare": "style__compare___2sYLi",
	"bottom": "style__bottom___3HKIF",
	"transparentBg": "style__transparentBg___3_IEC"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/button/style.css
// module id = 676
// module chunks = 0